import React, { Fragment, useState, useEffect } from 'react';
import { useSelector} from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import GetUserDevices from './GetUserDevices'

import local from './local/add_localisation';
import API from '../API/api';

var counter =0;

export default function AddNewDevice(){
    const navigate = useNavigate();
    var labels = [];
    var msg = null;

    const setup = useSelector((state) => state.site.setup);
    const [AllIs, setAllIs] = useState({done:false, error:null, readylst:false, readyTypes:false});

    // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
    let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

    if(localStorage.user){
        var user = JSON.parse(localStorage.getItem("user"));
    } else {
        navigate(`/${LANG}/login`, { replace: true });
        return null;
    }
    
   
    // Selection values
    const [selTypeOption, setTypeOption] = useState({ value: 'empty', label: local[LANG].empty, pfx:'dev' });
    //const [selTypeOption, setTypeOption] = useState(null);
    const [selDevOption, setDevOption] = useState(null);
    
    // Selection options
    const [types, setTypes] = useState([{ value: 'dalnomer', label: local[LANG].dalnomer },{ value: 'lazlevel', label: local[LANG].lazlevel }]);
    const [devList, setDevList] = useState([{ value: 'dalnomer', label: local[LANG].dalnomer },{ value: 'lazlevel', label: local[LANG].lazlevel }]);
    
    

useEffect(() => { 
    GetDevOptions('cat', 'types');
}, [] );
    

useEffect(() => { 
    if(selTypeOption.value !== 'empty'){
        GetDevOptions(selTypeOption.value, 'devlist');
    }
}, [selTypeOption.value] );

    
if(AllIs.error){
return (
    <Fragment>
        <div className="login">ADD USER DEV: {AllIs.error.message}</div>
    </Fragment>
)
} 


return(
<Fragment>
<GetUserDevices counter={counter}/>
{
    
AllIs.readyTypes? 

    <form name="adddev" onSubmit={(ev)=>{SaveDATA(ev)}} className="login">
        { msg !==null ? <p>{msg}</p> : null}
        <h2>{local[LANG].newadd_ttl}</h2>
            <Select
                            //defaultValue={selTypeOption}
                            value={selTypeOption}
                            noOptionsMessage={() => "No more options"}
                            onChange={setTypeOption}
                            options={types}
                            isSearchable={false}
                            styles={{
                                control: (baseStyles, state) => ({
                                ...baseStyles,
                                fontSize: '11pt',
                                padding:'px 0px',
                                marginTop: '1em'
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    fontSize: '11pt',
                                }),
                            }}

            />
        {
            AllIs.readylst ? <Fragment>
                                    <Select
                                        defaultValue={selDevOption}
                                        onChange={setDevOption}
                                        options={devList}
                                        isSearchable={false}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                fontSize: '11pt',
                                                padding:'0px 0px',
                                                marginTop: '1em'
                                            }),
                                            option: (baseStyles, state) => ({
                                                ...baseStyles,
                                                fontSize: '11pt',
                                                }),
                                            }}
                                        placeholder={local[LANG].model}
                                    />
                                    <label for="date">{local[LANG].date}
                                    <input required type="date" name="dateofby" placeholder={local[LANG].dateofby} autoComplete='on'/>
                                    </label>
                                    <label for="serialn">
                                    <input required type="text" name="serialn" placeholder={local[LANG].serialn} autoComplete='on'/>
                                    </label>
                                    <p className='warn wht'>{local[LANG].warn}</p>
                                    <br/>
                                    <button type="submit" className="btn submit w50">{local[LANG].submit}</button>
                            </Fragment> :null
        }
    </form> :null
}                

</Fragment>
)   

function GetDevOptions(parent_id, type){

    AllIs.readylst = false;
    setDevOption(null);

    const form = new FormData()
          form.append('lang', setup.lang);
          form.append('parent_id', parent_id);
          form.append('type', type);
  API.postFormData('loadevtypes', form)
    .then(data => {
if(type ==='types'){
    AllIs.readyTypes = true;
    setTypes(data.list);
} else {
    AllIs.readylst = true;
    setDevList(data.list);
}
    })
    .catch(error => {
        //setAllIs({...AllIs, error:error});
    });
  }


 function SaveDATA(ev){
    ev.preventDefault()
    var sndForm = document.forms.adddev;
    let myDate = sndForm.elements.dateofby.value;
    let newDate = Date.parse(new Date(myDate))/1000;

    const form = new FormData()
          form.append('lang', setup.lang);
          form.append('ttl', selDevOption.label);
          form.append('pfx', selDevOption.pfx);
          form.append('devid', selDevOption.value);
          form.append('sn', sndForm.elements.serialn.value);
          form.append('usr', user.usr);
          form.append('date', newDate);

        API.postFormData('adduserdev', form)
    .then(data => {
        let msg = data.resp;
        AllIs.readylst = false;

        if(msg ==='ok'){
            sndForm.reset();
            setDevOption(null);
            setTypeOption({ value: 'empty', label: local[LANG].empty, pfx:'dev' });
            counter++; //let update user dev list
        } else {
            //setMsg({...AllIs, error:{message:msg}});
            //setMsg(msg);
        }
        
    })
    .catch(error => {
        setAllIs({...AllIs, error:error});
    });
 }

} 